import styled from 'styled-components';

export const Wrap = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
`;
